import type { Translations } from './types';

export const ar: Translations = {
  appName: 'مدرب الأبجدية العسكرية',
  converter: 'محوّل',
  quiz: 'اختبار الحروف',
  wordQuiz: 'اختبار الكلمات',
  settings: 'الإعدادات',
  enterText: 'أدخل النص للتحويل',
  placeholder: 'اكتب رسالتك هنا...',
  natoAlphabet: 'الأبجدية العسكرية',
  playPronunciation: 'تشغيل النطق',
  stop: 'إيقاف',
  quickReference: 'مرجع سريع',
  showLess: 'إظهار أقل',
  viewFullAlphabet: 'عرض الأبجدية الكاملة ←',
  copied: 'تم النسخ!',
  copyFailed: 'فشل في النسخ',
  speechNotAvailable: 'تركيب الكلام غير متاح',
  voiceSettings: 'إعدادات الصوت',
  textToSpeechVoice: 'صوت تحويل النص إلى كلام',
  testVoice: 'اختبار الصوت',
  notifications: 'الإشعارات',
  spacedRepetitionReminders: 'تذكيرات التكرار المتباعد',
  notificationDescription: 'احصل على إشعارات يومية للممارسة',
  language: 'اللغة',
  interfaceLanguage: 'لغة الواجهة',
  about: 'حول مدرب الأبجدية العسكرية',
  question: 'سؤال',
  questionCount: '{current} من {total}',
  reviewYourAnswers: 'مراجعة إجاباتك',
  typeNatoWordForLetter: 'اكتب كلمة الناتو للحرف {letter}',
  startVoiceInput: 'بدء إدخال الصوت',
  stopVoiceInput: 'إيقاف إدخال الصوت',
  aboutDescription:
    'تعلم الأبجدية الصوتية العسكرية من خلال الاختبارات التفاعلية والتكرار المتباعد.',
  version: 'الإصدار 1.0.0',
  builtWith: 'مبني بتقنيات الويب الحديثة',
  currentStreak: 'السلسلة الحالية',
  totalSessions: 'إجمالي الجلسات',
  accuracy: 'الدقة',
  learningProgress: 'تقدم التعلم',
  startQuiz: 'بدء الاختبار',
  restartQuiz: 'إعادة تشغيل الاختبار',
  nextQuestion: 'السؤال التالي',
  submitAnswer: 'إرسال الإجابة',
  showStats: 'إظهار الإحصائيات',
  hideStats: 'إخفاء الإحصائيات',
  correctAnswer: 'الإجابة الصحيحة',
  yourAnswer: 'إجابتك',
  correct: 'صحيح',
  incorrect: 'خاطئ',
  sessionComplete: 'انتهت الجلسة!',
  score: 'النتيجة',
  tryAgain: 'حاول مرة أخرى',
  hint: 'تلميح',
  femaleVoice: 'صوت أنثوي',
  maleVoice: 'صوت ذكوري',
  robotVoice: 'صوت آلي',
  dailyReminders:
    'ستتلقى تذكيرات يومية لممارسة الأبجدية العسكرية بناءً على تقدم تعلمك.',
  speakAnswer: 'تحدث بإجابتك',
  voiceInputActive: 'الاستماع...',
  adaptiveLearning: 'التعلم التكيفي',
  skipQuestion: 'تخطي',
  pressEnterToSubmit: 'اضغط Enter للإرسال',
  pressEscapeToSkip: 'اضغط Escape للتخطي',
  exampleAnswers: 'مثال: "Alpha", "Bravo", "Charlie"',
  notificationsPanelTitle: 'الإشعارات',
  markAllAsRead: 'تحديد الكل كمقروء',
  noNotifications: 'لا توجد إشعارات',
  natoHints: {
    A: 'الحرف الأول من الأبجدية اليونانية',
    B: 'أحسنت، تصفيق!',
    C: 'حرف C الصوتي، مثل الاسم',
    D: 'تشكيل مثلثي للنهر',
    E: 'انعكاس الصوت',
    F: 'رقصة القاعة',
    G: 'رياضة بالعصي والحفر',
    H: 'مكان للمبيت',
    I: 'بلد آسيوي كبير',
    J: 'بطلة شكسبير',
    K: 'وحدة الوزن (1000 جرام)',
    L: 'عاصمة البيرو',
    M: 'اختصار للميكروفون',
    N: 'شهر الخريف',
    O: 'جائزة الأكاديمية',
    P: 'أب، غير رسمي',
    Q: 'مقاطعة كندية',
    R: 'شخصية شكسبير',
    S: 'سلسلة جبال',
    T: 'رقصة أرجنتينية',
    U: 'نفس الملابس للجميع',
    V: 'فائز، بطل',
    W: 'مشروب كحولي قوي',
    X: 'التصوير الطبي',
    Y: 'لاعب بيسبول أمريكي',
    Z: 'أمة محاربة أفريقية',
  },
  learning: 'التعلم',
  review: 'المراجعة',
  mastered: 'متقن',
  lastFiveTimes: 'آخر 5 أوقات للاختبار',
  quizTimes: 'أوقات الاختبار',
  bestTime: 'أفضل وقت',
  noTimesRecorded: 'لم يتم تسجيل أوقات',
  spacedRepetitionDescription:
    'كل مجموعة من 10 أسئلة تتكيف حسب أداءك باستخدام التكرار المتباعد.',
  theme: 'السمة',
  lightTheme: 'فاتح',
  darkTheme: 'داكن',
  rainbowTheme: 'قوس قزح',
  systemTheme: 'النظام',
  appearance: 'المظهر',
  chooseTheme: 'اختر المظهر الذي تفضله',
  speechRate: 'معدل الكلام',
  pitch: 'حدة الصوت',
  volume: 'مستوى الصوت',
  // Custom Word Input
  enterCustomWord: 'أدخل كلمة مخصصة',
  enterYourWordOrPhrase: 'أدخل كلمتك أو عبارتك...',
  useThisWord: 'استخدم هذه الكلمة',
  // WordDisplay localization
  currentWordLabel: 'الكلمة الحالية',
  customWordLabel: 'مخصص',
  currentWordSpeech: 'الكلمة الحالية هي: {word}',
  difficultyLabels: {
    easy: 'سهل',
    medium: 'متوسط',
    hard: 'صعب',
  },
  categoryLabels: {
    animals: 'الحيوانات',
    places: 'الأماكن',
    nature: 'الطبيعة',
    technology: 'التكنولوجيا',
    home: 'المنزل',
    objects: 'الأشياء',
    transport: 'النقل',
  },
  // NATO Input specific translations
  natoInputTitle: 'إدخال أبجدية الناتو الخاصة بك',
  natoInputPlaceholder: 'أدخل كلمات الناتو: "Alpha Bravo Charlie..."',
  natoInputListening: 'جاري الاستماع...',
  natoInputLiveScore: 'النتيجة المباشرة',

  // Quiz Header translations
  wordQuizInstructions:
    'قم بتحويل الكلمة أدناه إلى أبجدية الناتو. قل كل كلمة ناتو مفصولة بمسافات أو فواصل.',

  // Quiz Actions translations
  retry: 'إعادة المحاولة',
  checkAnswer: 'فحص الإجابة',
  newRandomWord: 'كلمة عشوائية جديدة',
  cancelCustom: 'إلغاء المخصص',
  customWord: 'كلمة مخصصة',

  // Quiz Results translations
  perfect: 'مثالي!',
  results: 'النتائج',
  expectedNato: 'الناتو المتوقع:',
  play: 'تشغيل',
  letterByLetter: 'حرف بحرف:',
};
